<template>
    <div>
      <b-loading :is-full-page="false" v-model="loading" :can-cancel="true" />

      <p class="mb-3">
          <a href="https://help.yourstake.org/migration/knowledge/people-integrations" target="_blank" rel="noopener noreferrer">
            <b-icon
                pack="fas"
                icon="info"
                class="is-primary"
            />
          Learn more about these integrations
          </a>
      </p>

      <div class="mygrid">
        <div class="box ">
            <a @click="requestIntegration('addepar')" class="is-flex">
                <figure class="image is-flex ">
                  <img class="is-vcentered" :src="$root.$data.STATIC_ROOT + 'images/integrations/addepar-logo.png'">
                </figure>
            </a>
        </div>

        <div class="box is-flex">
          <a @click="requestIntegration('orion')" class="is-flex">
              <figure class="image is-flex ">
                <img class="is-vcentered" :src="$root.$data.STATIC_ROOT + 'images/integrations/orion-advisor-tech-logo.png'">
              </figure>
          </a>
        </div>

        <div class="box">
        <a @click="requestIntegration('schwab')" class="is-flex">
          <figure class="image is-flex">
            <img class="is-vcentered" :src="$root.$data.STATIC_ROOT + 'images/integrations/charles-schwab.jpg'">
          </figure>
        </a>
        </div>

        <div class="box">
          <a @click="requestIntegration('raymondjames')" class="is-flex">
              <figure class="image is-flex">
                <img class="is-vcentered" :src="$root.$data.STATIC_ROOT + 'images/integrations/raymondjames-logo.png'">
              </figure>
          </a>
        </div>

        <div class="box">
          <a @click="requestIntegration('fidelity')" class="is-flex">
              <figure class="image is-flex">
                <img class="is-vcentered" :src="$root.$data.STATIC_ROOT + 'images/integrations/fidelity-logo.png'">
              </figure>
          </a>
        </div>

        <div class="box">
          <a @click="requestIntegration('altruist')" class="is-flex">
              <figure class="image is-flex">
                <img class="is-vcentered" :src="$root.$data.STATIC_ROOT + 'images/integrations/altruist-logo.jpg'">
              </figure>
          </a>
        </div>
      </div>
    </div>
  </template>


<script>
// import SubComponent from '../components/SubComponent'

export default {
  name: 'IntegrationsLinks',
  components: {
    // Subcomponents
  },
  props: {
    // Inputs
  },
  data() {
    return {
      // Local variables
      loading: false,
    };
  },
  computed: {
  },
  watch: {

  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    requestIntegration: async function(integration) {
      this.loading = true;

      const response = await fetch(
          `/api/v1/request-integration/`,
          {
            method: 'POST',
            headers: {
              'X-CSRFToken': this.$root.$data.csrfToken,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              'integration': integration,
            }),
          },
      );
      const data = await response.json();

      this.success = data.success;
      this.loading = false;

      if (this.success) {
        window.open(data.integration_context.zoho_url, '_blank').focus();
        this.$emit('close');
      }

      if (!this.success) {
        this.$buefy.notification.open({
          duration: 10000,
          message: `Seems we are having an issue doing that. Please try again. If it doesn't work, email us at support@yourstake.org`,
          position: 'is-bottom-right',
          type: 'is-danger',
        });
      }
    },
  },
};
</script>


<style lang="scss" scoped>
  .mygrid {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    align-items: center;

    .box {
      width: 150px;
      height: 150px;
      margin: 1rem;
    }
  }

  div > a > figure > img {
    margin: auto;
  }
</style>
